import React from "react";
import ReactTable from "react-table";
import { connect } from "react-redux";
import { requests } from "../../api/request";

import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormInput
} from "shards-react";

import _ from 'lodash';

class Tables extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchURL: this.props.parent ? '/' + this.props.parent + '/' + this.props.selected + '/' + this.props.dataName : '/' + this.props.dataName,
      dataColumns: this.props.dataColumns,
      title: this.props.title,
      selected: this.props.selected,
      data: this.props.tableData.data.data ? this.props.tableData.data.data : [],
      pageSize: this.props.tableData.data.count,
      pageTotal: Math.ceil(this.props.tableData.data.total / this.props.tableData.data.count),
      loading: false,
      searchValue: null,
      page:0,
    };
    this.servicesValue = _.debounce(this.servicesValue, 1000);
  }

  componentDidMount() {
    this._mounted = true
  }

  componentWillUnmount() {
    this._mounted = false
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.research === false) {
      this.setState({
        pageSize: nextProps.tableData.data.count,
        data: nextProps.tableData.data.data,
        pageTotal: Math.ceil(nextProps.tableData.data.total / nextProps.tableData.data.count),
        loading: false,
      })
    }
  }

  handleFilterSearch(e) {
    if (this.state.selected) {
      this.servicesValue({uuid: this.state.selected, search: e.target.value})
    } else {
      this.servicesValue({search: e.target.value})
    }
  }

  servicesValue = (value) => {
    this.setState({
      loading: true,
    });
    let search = this.props.searchData(value);
    let searchUrl;
    let searchValue;
    if (value.search.length > 0) {
      searchValue = value.search;
      switch (search.type) {
        case 'search-practitioners':
          searchUrl = '/practitioners/search';
          break;
        case 'search-consultations':
          searchUrl = '/appointments/search';
          break;
        case 'search-patients':
          searchUrl = '/patients/search';
          break;
        case 'search-patient-consultation':
          searchUrl = '/patients/' + this.state.selected + '/appointments/search';
          break;
        case 'search-practitioner-consultation':
          searchUrl = '/practitioners/' + this.state.selected + '/appointments/search';
          break;
        case 'search-languages':
          searchUrl = '/languages/search';
          break;
      }
    } else {
      searchUrl = this.props.parent ? '/' + this.props.parent + '/' + this.props.selected + '/' + this.props.dataName : '/' + this.props.dataName;
      searchValue = null;
    }
    this.setState({
      searchURL: searchUrl,
      searchValue: searchValue,
      page:0,
    });
  };

  render() {
    const { dataColumns, title } = this.state;
    return (
      <Card className="p-0 mb-4">
        <CardHeader className="p-0">
          <Container fluid className="filters-table border-bottom">
            <Row>
              <Col className="ml-auto d-flex">
                <span className="table__filters__title">{title}</span>
              </Col>
              <Col className="table__filters__search d-flex" md="6">
                <InputGroup seamless size="sm" className="ml-auto">
                  <InputGroupAddon type="prepend">
                    <InputGroupText>
                      <i className="material-icons">search</i>
                    </InputGroupText>
                  </InputGroupAddon>
                  <FormInput className="search-input" onChange={e => this.handleFilterSearch(e)}/>
                  {this.props.tableData.searching && (
                    <div className="search-loader">
                      <div className="text-center d-block">
                        <div className="spinner-border" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    </div>
                  )}
                </InputGroup>
              </Col>
            </Row>
          </Container>
        </CardHeader>
        <CardBody className="p-0">
          <ReactTable
            columns={dataColumns}
            data={this.state.data}
            loading={this.state.loading}
            pageSize={this.state.pageSize}
            showPageSizeOptions={false}
            resizable={false}
            previousText='Précédent'
            nextText='Suivant'
            noDataText='Pas de donnée trouvée'
            ofText='sur'
            sortable={false}
            filterable={false}
            pages={this.state.pageTotal}
            onPageChange={page => this.setState({page})}
            page={this.state.page}
            manual
            onFetchData={(state) => {
              if (this._mounted) {
                this.setState({loading: true});
                requests.get(this.state.searchURL, {
                  search: this.state.searchValue,
                  _page: state.page + 1,
                }).then((res) => {
                  this.setState({
                    pageSize: res.data.count,
                    data: res.data.data,
                    loading: false,
                  })
                })
              }
            }}
          />
        </CardBody>
      </Card>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    tableData: state[ownProps.tableData],
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    searchData(e) {
      return dispatch(ownProps.dataSearch(e))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Tables);



// WEBPACK FOOTER //
// ./src/components/tables/index.js